import { authRoles } from "../../../auth/authRoles";
import EditLaporanKeuangan from "./EditLaporanKeuangan";
import LaporanKeuangan from "./LaporanKeuangan";
import TambahLaporanKeuangan from "./TambahLaporanKeuangan";

const laporanKeuanganRoute = [
  {
    path: "/laporan_keuangan/edit/:id",
    exact: true,
    component: EditLaporanKeuangan,
    auth: authRoles.all,
  },
  {
    path: "/laporan_keuangan/tambah",
    exact: true,
    component: TambahLaporanKeuangan,
    auth: authRoles.all,
  },
  {
    path: "/laporan_keuangan",
    exact: true,
    component: LaporanKeuangan,
    auth: authRoles.all,
  },
];

export default laporanKeuanganRoute;
